import React from 'react';

import DestructiveActionMenuItem from '@dashboard/components/destructive-action-triggers/DestructiveActionMenuItem';
import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useCreateDuplicateTemplateMutation } from '@dashboard/generated/wp/platform';
import { useShowTemplateNavigate } from '@dashboard/hooks/navigate/usePlatformNavigator';
import { ContentCopyOutlined } from '@mui/icons-material';

type Props = {
  id: string;
  onClose: () => void;
  type: 'TEMPLATE' | 'LAYOUT';
};

export default function DuplicateTemplateButton({ id, onClose, type }: Props) {
  const [executeMutation, { loading }] = useCreateDuplicateTemplateMutation();
  const showTemplate = useShowTemplateNavigate();

  const onClick = async () => {
    const { data } = await executeMutation({ variables: { id } });
    onClose();
    if (data) {
      if (data.createDuplicateTemplate.type === 'LAYOUT') {
        alertSuccess('Layout duplicated');
      } else {
        alertSuccess('Template duplicated');
      }
      showTemplate(data.createDuplicateTemplate.id);
    }
  };

  const isLayout = type === 'LAYOUT';
  const title = isLayout ? 'Duplicate layout?' : 'Duplicate template?';
  const renderDescription = () => {
    if (isLayout) {
      return 'This will create a new copy of your layout.';
    }
    return 'This will create a new copy of your template.';
  };

  return (
    <DestructiveActionMenuItem
      buttonIcon={<ContentCopyOutlined fontSize="small" />}
      buttonText="Duplicate"
      title={title}
      description={renderDescription()}
      loading={loading}
      onSubmit={onClick}
      confirmButtonLabel="Yes, duplicate"
    />
  );
}
